<template>
  <div>
    <img :src="$t('pages.welcome.ripph_img')">
    <img src="/img/ophq.jpg">
  </div>
</template>
<script>
export default {
  name: 'Logo'
}
</script>
<style lang="scss" scoped>
  img {
    max-width: 20%;
  }
</style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/Logo.vue